module.exports = __webpack_public_path__ + "img/tema-1-2.fad24b11.svg";